import {schoolService} from "../SchoolService";

export class SchoolModuleSequence {
  id: number;
  level: number;
  content: any[];

  constructor(json: any) {
    this.id = json.id;
    this.level = json.level_id;
    this.content = json.content.reduce((acc, moduleId) => {
      const module = schoolService.state.modules.find(m => m.id === moduleId);
      if (module) {
        acc.push(module);
      }
      return acc;
    }, []);
  }
}

